import { useCallback } from "react";
import Button from "components/Button";
import TrashIcon from "components/Icons/TrashIcon";
import { useTranslation } from "react-i18next";
import Dialog from "components/Dialog";
import type MuxPlayerElement from "@mux/mux-player";
import useBoolean from "hooks/useBoolean";

interface DeleteExerciseRecordingVideoActionProps {
  videoRef: React.RefObject<MuxPlayerElement | null>;
  onDeleteVideo: () => void;
}

function DeleteExerciseRecordingVideoAction(props: DeleteExerciseRecordingVideoActionProps) {
  const { videoRef, onDeleteVideo } = props;

  const { value: open, toggle } = useBoolean();

  const { t } = useTranslation();

  const onOpen = useCallback(() => {
    toggle();
    videoRef.current?.pause();
  }, [toggle, videoRef]);

  const onClose = useCallback(() => {
    toggle();
    videoRef.current?.play();
  }, [toggle, videoRef]);

  return (
    <>
      <Button size="small" variant="danger" startIcon={<TrashIcon fontSize="small" />} onClick={onOpen}>
        {t("global.delete_button_text")}
      </Button>

      <Dialog
        closeAfterTransition={false}
        id="confirm-dashboard-delete-dialog"
        open={open}
        onClose={onClose}
        title={t("athlete.delete_video_dialog_title")}
        subTitle={t("athlete.delete_video_dialog_sub_title")}
        text={t("athlete.delete_video_dialog_body")}
        confirmButton={
          <Button fullWidth variant="danger" size="small" onClick={onDeleteVideo}>
            {t("athlete.delete_video_dialog_delete_button_text")}
          </Button>
        }
        cancelButton={
          <Button fullWidth variant="tertiary" size="small" onClick={onClose}>
            {t("global.cancel_button_text")}
          </Button>
        }
      />
    </>
  );
}

export default DeleteExerciseRecordingVideoAction;
